/**
 * @generated SignedSource<<86cfc9f17b22e5a43ab553bb8d5fa9ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WhatToSeeListRow_whatToSee$data = {
  readonly id: string;
  readonly location: string | null;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity">;
  readonly " $fragmentType": "WhatToSeeListRow_whatToSee";
};
export type WhatToSeeListRow_whatToSee$key = {
  readonly " $data"?: WhatToSeeListRow_whatToSee$data;
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeListRow_whatToSee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WhatToSeeListRow_whatToSee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityTableRow_entity"
    }
  ],
  "type": "WhatToSee",
  "abstractKey": null
};

(node as any).hash = "c9257c89d851bb0558f9d009d7efa1d2";

export default node;
